import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ROLE } from '../enums';
import { AuthenticationService } from '../services/authentication.service';
import { MethodsService } from '../utils/methods.service';

@Injectable({
	providedIn: 'root'
})
export class CollaboratorGuard {
	private _authenticationService = inject(AuthenticationService);
	private _methodsService = inject(MethodsService);

	canActivate(_route: ActivatedRouteSnapshot): boolean {
		const currentUser = this._authenticationService.currentUser;
		if (currentUser) return this._authenticationService.selectedRole === ROLE.COLLABORATOR;
		return false;
	}
}
